import React from "react";
import "./AnnouncementSection.css";

const AnnouncementSection = () => {
  return (
    <section className="niecce-ann-section">

      {/* LEFT COLUMN — IMAGES */}
      <div className="ann-left">

        <div className="ann-img-card">
          <img 
            src="https://static.wixstatic.com/media/6870b3_e92e0181dc3945588f9ff406a13470bb~mv2.png" 
            alt="Story & Rhymes"
            title="NIECCE teacher training story and rhymes activity"
          />
        </div>

      </div>

      {/* RIGHT COLUMN — CONTENT */}
      <div className="ann-right">

        <div className="ann-img-card wide">
          <img 
            src="https://static.wixstatic.com/media/6870b3_f2c5371c550143ee80bbfa03157a1a3f~mv2.png" 
            alt="Prizes"
            title="NIECCE teacher training competition prizes"
          />
        </div>

        <h2 className="ann-title">
          🎉 Important Announcement
        </h2>

        <p className="ann-sub">
          NTT Course (with Montessori) — <br />
          <strong>New batches starting soon!</strong>
        </p>

        <div className="ann-highlight-box">
          <p>
            Congratulations to all the winners!  
            Prize distribution will happen in Bengaluru during the NTT 
            Graduation Ceremony. Date & time will be announced soon.
          </p>
        </div>

        <a 
          href="https://docs.google.com/document/d/1Yj8GtnrsEYdFbxhOh5vay6uucjcYSPGudRp1bwmY3lI/edit?usp=sharing" 
          className="ann-link"
          target="_blank"
        >
          Read Terms & Conditions →
        </a>

        <div className="ann-buttons">
          <a href="/course/admission" className="btn-primary">
            Admission Enquiry
          </a>

          <a href="/courses" className="btn-secondary">
            View Courses
          </a>
        </div>
{/* 
        <div className="ann-img-card small">
          <img 
            src="https://static.wixstatic.com/media/6870b3_5b1e348b039c4745a494e68024625c06~mv2.png" 
            alt="Event Banner"
          />
        </div> */}

      </div>

    </section>
  );
};

export default AnnouncementSection;
